import { render, staticRenderFns } from "./WithdrawWallet.vue?vue&type=template&id=af73d8a0&scoped=true&"
import script from "./WithdrawWallet.vue?vue&type=script&lang=ts&"
export * from "./WithdrawWallet.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawWallet.vue?vue&type=style&index=0&id=af73d8a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73d8a0",
  null
  
)

export default component.exports